import { logger } from './logger';
import { trackCoreWebVitals, trackPerformance } from './analytics/performance';

function currentPagePath(): string {
  return typeof window !== 'undefined' ? window.location.pathname : '';
}

/**
 * Production RUM for Core Web Vitals (complements lab Lighthouse).
 * Uses web-vitals/attribution so CLS largest-shift targets reach GA4.
 */
export function initWebVitals(): void {
  if (!import.meta.env.PROD || typeof window === 'undefined') {
    return;
  }
  void import('web-vitals/attribution')
    .then(({ onLCP, onINP, onCLS }) => {
      onLCP((metric) => {
        const page_path = currentPagePath();
        trackCoreWebVitals('largest_contentful_paint', metric.value, { page_path });
        trackPerformance('LCP', metric.value, 'ms', { page_path });
      });
      onCLS((metric) => {
        const page_path = currentPagePath();
        const attribution = {
          page_path,
          largest_shift_target: metric.attribution.largestShiftTarget,
          load_state: metric.attribution.loadState,
          largest_shift_value: metric.attribution.largestShiftValue,
        };
        trackCoreWebVitals('cumulative_layout_shift', metric.value, attribution);
        trackPerformance('CLS', metric.value, 'score', attribution);
      });
      onINP((metric) => {
        const page_path = currentPagePath();
        // GA4 / CWV RUM tab query `interaction_to_next_paint` (legacy label `INP` kept via trackPerformance).
        trackCoreWebVitals('interaction_to_next_paint', metric.value, { page_path });
        trackPerformance('INP', metric.value, 'ms', { page_path });
      });
    })
    .catch((err) => {
      logger.debug('web-vitals init skipped', { err });
    });
}
